import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export default function KPICard({ label, value, hint, icon: Icon, tone = "default", testId }) {
  const tones = {
    default: "border-stone-200",
    success: "border-emerald-200 bg-emerald-50/40",
    warn: "border-amber-200 bg-amber-50/40",
    danger: "border-rose-200 bg-rose-50/40",
  };
  const iconTones = {
    default: "bg-stone-100 text-stone-700",
    success: "bg-emerald-100 text-emerald-700",
    warn: "bg-amber-100 text-amber-700",
    danger: "bg-rose-100 text-rose-700",
  };
  return (
    <Card
      data-testid={testId}
      className={cn(
        "p-5 rounded-xl border transition-all hover:-translate-y-0.5 hover:shadow-sm bg-white",
        tones[tone]
      )}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-stone-500 font-mono">
            {label}
          </div>
          <div className="mt-2 font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-stone-950 truncate">
            {value}
          </div>
          {hint && (
            <div className="mt-1 text-xs text-stone-500 font-body truncate">{hint}</div>
          )}
        </div>
        {Icon && (
          <div className={cn("h-10 w-10 rounded-lg flex items-center justify-center", iconTones[tone])}>
            <Icon className="h-5 w-5" />
          </div>
        )}
      </div>
    </Card>
  );
}
